import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Preferences } from "@capacitor/preferences";
import API from "../api";

function Profile() {
  const [profile, setProfile] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    role: "",
  });

  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await API.get("/me");
      setProfile(res.data);
    } catch (err) {
      alert(err?.response?.data?.message || "Impossible de charger le profil");
    }
  };

  const updateProfile = async () => {
    try {
      const res = await API.put("/me", profile);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      alert("Profil mis à jour");
    } catch (err) {
      alert(err?.response?.data?.message || "Impossible de modifier le profil");
    }
  };

  const updatePassword = async () => {
    try {
      await API.put("/me/password", passwords);

      setPasswords({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });

      alert("Mot de passe modifié");
    } catch (err) {
      alert(err?.response?.data?.message || "Impossible de modifier le mot de passe");
    }
  };

  const logout = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");

    await Preferences.remove({ key: "token" });
    await Preferences.remove({ key: "refreshToken" });

    navigate("/login");
    window.location.reload();
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.avatar}>{profile.firstname?.[0] || "?"}</div>

        <div>
          <div style={styles.name}>
            {profile.firstname} {profile.lastname}
          </div>
          <div style={styles.role}>{formatRole(profile.role)}</div>
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.sectionTitle}>Mes informations</div>

        <input
          style={styles.input}
          placeholder="Prénom"
          value={profile.firstname || ""}
          onChange={(e) => setProfile({ ...profile, firstname: e.target.value })}
        />

        <input
          style={styles.input}
          placeholder="Nom"
          value={profile.lastname || ""}
          onChange={(e) => setProfile({ ...profile, lastname: e.target.value })}
        />

        <input
          style={styles.input}
          placeholder="Email"
          value={profile.email || ""}
          onChange={(e) => setProfile({ ...profile, email: e.target.value })}
        />

        <input
          style={styles.input}
          placeholder="Téléphone"
          value={profile.phone || ""}
          onChange={(e) => setProfile({ ...profile, phone: e.target.value })}
        />

        <button style={styles.primaryBtn} onClick={updateProfile}>
          Sauvegarder mes infos
        </button>
      </div>

      <div style={styles.card}>
        <div style={styles.sectionTitle}>Mot de passe</div>

        <input
          style={styles.input}
          type="password"
          placeholder="Mot de passe actuel"
          value={passwords.currentPassword}
          onChange={(e) =>
            setPasswords({ ...passwords, currentPassword: e.target.value })
          }
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Nouveau mot de passe"
          value={passwords.newPassword}
          onChange={(e) =>
            setPasswords({ ...passwords, newPassword: e.target.value })
          }
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Confirmer le nouveau mot de passe"
          value={passwords.confirmPassword}
          onChange={(e) =>
            setPasswords({ ...passwords, confirmPassword: e.target.value })
          }
        />

        <button style={styles.secondaryBtn} onClick={updatePassword}>
          Modifier le mot de passe
        </button>
      </div>

      <div style={styles.logoutWrapper}>
        <button style={styles.logoutBtn} onClick={() => setShowLogoutModal(true)}>
          🚪 Se déconnecter
        </button>
      </div>

      {showLogoutModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalBox}>
            <div style={styles.modalIcon}>🚪</div>
            <h3 style={styles.modalTitle}>Se déconnecter ?</h3>
            <p style={styles.modalText}>
              Tu devras te reconnecter pour accéder à l’application.
            </p>

            <div style={styles.modalActions}>
              <button
                style={styles.modalCancel}
                onClick={() => setShowLogoutModal(false)}
              >
                Annuler
              </button>

              <button style={styles.modalConfirm} onClick={logout}>
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function formatRole(role) {
  switch (role) {
    case "admin":
      return "Admin";
    case "apprenti":
      return "Apprenti";
    case "compagnon":
      return "Compagnon";
    case "maitre":
      return "Maître";
    default:
      return role || "";
  }
}

export default Profile;

const styles = {
  container: {
    height: "100vh",
    overflowY: "auto",
    background: "#0A0F14",
    color: "white",
    padding: 20,
    paddingBottom: 150,
    boxSizing: "border-box",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: 15,
    marginBottom: 22,
  },

  avatar: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    background: "#111",
    border: "1px solid rgba(212,175,55,0.4)",
    color: "#D4AF37",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 26,
    fontWeight: "700",
  },

  name: {
    fontSize: 20,
    fontWeight: "700",
    color: "#D4AF37",
  },

  role: {
    fontSize: 13,
    color: "rgba(255,255,255,0.6)",
    marginTop: 4,
  },

  card: {
    background: "rgba(255,255,255,0.035)",
    border: "1px solid rgba(212,175,55,0.12)",
    borderRadius: 18,
    padding: 16,
    marginBottom: 16,
  },

  sectionTitle: {
    color: "#D4AF37",
    fontWeight: "700",
    marginBottom: 12,
  },

  input: {
    width: "100%",
    padding: 13,
    marginBottom: 10,
    borderRadius: 12,
    border: "1px solid rgba(212,175,55,0.18)",
    background: "#020617",
    color: "white",
    boxSizing: "border-box",
  },

  primaryBtn: {
    width: "100%",
    padding: 14,
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg, #D4AF37, #F1D77A)",
    color: "#000",
    fontWeight: "700",
    marginTop: 6,
  },

  secondaryBtn: {
    width: "100%",
    padding: 14,
    borderRadius: 12,
    border: "1px solid rgba(212,175,55,0.4)",
    background: "rgba(212,175,55,0.08)",
    color: "#D4AF37",
    fontWeight: "700",
    marginTop: 6,
  },

  logoutWrapper: {
    marginTop: 20,
    marginBottom: 30,
  },

  logoutBtn: {
    width: "100%",
    padding: 14,
    borderRadius: 12,
    border: "1px solid #ef4444",
    background: "linear-gradient(135deg, #ef4444, #dc2626)",
    color: "white",
    fontWeight: "700",
  },

  modalOverlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.75)",
    backdropFilter: "blur(4px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    zIndex: 9999,
  },

  modalBox: {
    width: "100%",
    maxWidth: 340,
    background: "#0A0F14",
    border: "1px solid rgba(212,175,55,0.35)",
    borderRadius: 22,
    padding: 22,
    boxShadow: "0 20px 70px rgba(0,0,0,0.9)",
    textAlign: "center",
  },

  modalIcon: {
    fontSize: 34,
    marginBottom: 10,
  },

  modalTitle: {
    color: "#D4AF37",
    fontSize: 21,
    margin: "0 0 8px",
  },

  modalText: {
    color: "rgba(255,255,255,0.7)",
    fontSize: 14,
    lineHeight: 1.5,
    marginBottom: 20,
  },

  modalActions: {
    display: "flex",
    gap: 10,
  },

  modalCancel: {
    flex: 1,
    padding: 13,
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.06)",
    color: "white",
    fontWeight: "700",
  },

  modalConfirm: {
    flex: 1,
    padding: 13,
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg, #D4AF37, #F1D77A)",
    color: "#000",
    fontWeight: "800",
  },
};